import React from "react";
import { Input, Form } from "antd";
import { Controller } from "react-hook-form";
import "@ant-design/compatible/assets/index.css";

const InputForm = ({
  control,
  placeHolder = "",
  inputChange = () => {},
  name,
  required,
  errors,
  layOutSpan = 4,
  label,
  disable,
}) => {
  return (
    <Form.Item
      labelCol={{ span: layOutSpan }}
      label={label}
      name={name}
      validateStatus={errors && errors[name] ? "error" : ""}
      help={errors[name]?.message}
      required={required}
    >
      <Controller
        control={control}
        name={name}
        render={({ field: { onChange, value } }) => (
          <Input
            disabled={disable}
            allowClear
            placeholder={placeHolder}
            onChange={(values) => {
              onChange(values);
            }}
            value={value}
          />
        )}
      />
    </Form.Item>
  );
};

export default InputForm;
